import React from "react";
import { Mission } from "../HowItWorksSections/Mission";
import { AngeloEngine } from "../HowItWorksSections/AngeloEngine";
import { Circles } from "../HowItWorksSections/Circles";
import { SignUp } from "../HowItWorksSections/SignUp";
import './howItWork.scss'
const HowItWorksContent = (props) => {
  return (
    <div className="howItWork">
      <Mission />
      <AngeloEngine />
      <Circles />
      {/* <Assistance />
      <MobilePreview /> */}

      <SignUp />
    </div>
  );
};
export default HowItWorksContent;
